/* fit-loxx-trust boot — runs before deferred fit-app on many pages */
(function(){
  try {
    window.__fitLoxxBoot = true;
    window.__fitShopGridFix = true;
    if (typeof window._AutofillCallbackHandler === 'undefined') window._AutofillCallbackHandler = function(){};
    if (typeof window.AutofillCallbackHandler === 'undefined') window.AutofillCallbackHandler = function(){};
    if (!window.__fitQsPatch) {
      window.__fitQsPatch = true;
      var oqs = Document.prototype.querySelector;
      Document.prototype.querySelector = function(sel){
        try {
          if (sel === '.col-stat:nth-of-type(3) .n') {
            var el = oqs.call(this, '.col-stats .col-stat:nth-child(3) .n')
              || (this.querySelectorAll && this.querySelectorAll('.col-stats .col-stat .n')[2]);
            return el || document.createElement('span');
          }
        } catch (e1) {}
        return oqs.call(this, sel);
      };
    }
    if (!window.__fitAppendPatch) {
      window.__fitAppendPatch = true;
      var _ap = Node.prototype.appendChild;
      Node.prototype.appendChild = function(n){
        try {
          if (n && n.tagName === 'SCRIPT' && n.src && String(n.src).indexOf('/cdn/cdn/') !== -1) {
            n.src = String(n.src).replace('/cdn/cdn/', '/cdn/');
          }
        } catch (eA) {}
        return _ap.apply(this, arguments);
      };
    }
  } catch (e) {}
})();
/* fit-loxx-trust-v2 — homepage LOXX block + LOXX page hero trust expansion */
(function(){
  function path(){ return (location.pathname||'/').replace(/\/+$/,'')||'/'; }
  function isHome(){ var p=path(); return p==='/'||p==='/index'; }
  function isLoxxPage(){ return /\/pages\/loxx/.test(path()); }

  function homeNeeds(){
    /* home-v3: LOXX partnership copy is already in the hero — never inject striped pfld */
    if(document.querySelector('.hero[data-fit-hero="loxx-partnership-v3"]')) return false;
    if(document.querySelector('.hero-loxx-pack')) return false;
    var el=document.getElementById('loxx');
    if(!el) return true;
    if(el.classList.contains('hero-loxx-pack')) return false;
    if(el.closest && el.closest('.hero')) return false;
    var t=el.textContent||'';
    if(el.classList.contains('home-deprioritize')) return true;
    if(window.getComputedStyle && window.getComputedStyle(el).display==='none') return true;
    if(t.indexOf('military')!==-1 || t.indexOf('~100')!==-1) return false;
    if(t.indexOf('military')===-1) return true;
    return false;
  }

  function injectHome(){
    if(!isHome()||!homeNeeds()) return;
    var html=''
      +'<section class="section-pad pfld loxx-trust-visible" id="loxx" data-fit-loxx-inject="1" '
      +'style="display:block!important;visibility:visible!important;background:linear-gradient(180deg,#1a1f24 0%,#22282e 100%);color:#F4F1EC;padding:48px 20px;text-align:center">'
      +'<div style="max-width:1040px;margin:0 auto">'
      +'<div style="font-family:Barlow Condensed,Impact,sans-serif;font-weight:800;font-size:11px;letter-spacing:.16em;text-transform:uppercase;color:#46bfba;margin-bottom:12px">'
      +'Exclusive North American LOXX partner · Nobody else has this</div>'
      +'<h2 style="font-family:Barlow Condensed,Impact,sans-serif;font-weight:900;font-size:clamp(28px,4vw,52px);line-height:1;margin:0 0 16px">'
      +'A trust badge <em style="font-style:normal;color:#46bfba">only FIT carries.</em></h2>'
      +'<p style="font-size:17px;line-height:1.6;max-width:70ch;margin:0 auto 12px;opacity:.92">'
      +'<b style="color:#46bfba">This is the trust badge only FIT has.</b> LOXX has spent roughly <b style="color:#46bfba">~100 years</b> engineering connections that stay locked under load, vibration, and weather. '
      +'Their positive-lock hardware is trusted in <b style="color:#46bfba">military, aerospace, and marine</b> applications — where failure is not an option.</p>'
      +'<p style="font-size:16px;line-height:1.6;max-width:70ch;margin:0 auto 24px;opacity:.88">'
      +'That pedigree is why FIT partnered with LOXX as the <b style="color:#46bfba">exclusive North American partner</b> for glass protection. '
      +'Century-tested fastening on model-specific UTV and RV covers for highway miles and crosswinds — protecting glass that can run $500+ on a UTV and $3,000+ on an RV. '
      +'Magnets align. LOXX locks it down. <b style="color:#46bfba">Nobody else has this stack.</b></p>'
      +'<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(140px,1fr));gap:12px;max-width:900px;margin:0 auto 22px">'
      +'<div style="border:1px solid rgba(244,241,236,.16);border-radius:14px;padding:18px 14px"><div style="font-family:Barlow Condensed,sans-serif;font-weight:900;font-size:26px;color:#46bfba">~100 yr</div><div style="font-size:12px;font-weight:700;margin-top:8px;opacity:.9">LOXX fastening heritage</div></div>'
      +'<div style="border:1px solid rgba(244,241,236,.16);border-radius:14px;padding:18px 14px"><div style="font-family:Barlow Condensed,sans-serif;font-weight:900;font-size:18px;color:#46bfba;line-height:1.2">Mil · Aero · Marine</div><div style="font-size:12px;font-weight:700;margin-top:8px;opacity:.9">Where LOXX earns trust</div></div>'
      +'<div style="border:1px solid rgba(244,241,236,.16);border-radius:14px;padding:18px 14px"><div style="font-family:Barlow Condensed,sans-serif;font-weight:900;font-size:26px;color:#46bfba">300+ lb</div><div style="font-size:12px;font-weight:700;margin-top:8px;opacity:.9">Hold per LOXX fastener</div></div>'
      +'<div style="border:1px solid rgba(244,241,236,.16);border-radius:14px;padding:18px 14px"><div style="font-family:Barlow Condensed,sans-serif;font-weight:900;font-size:22px;color:#46bfba">Exclusive</div><div style="font-size:12px;font-weight:700;margin-top:8px;opacity:.9">NA partner for glass covers</div></div>'
      +'</div>'
      +'<div style="display:flex;flex-wrap:wrap;justify-content:center;gap:10px;margin-bottom:18px">'
      +'<div style="min-width:150px;border:1px solid rgba(244,241,236,.16);border-radius:12px;padding:14px"><div style="font-family:Barlow Condensed,sans-serif;font-weight:900;font-size:26px;color:#46bfba">$364</div><div style="font-size:11px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;margin-top:6px;opacity:.88">Magnetic · from</div></div>'
      +'<div style="min-width:150px;border:1.5px solid rgba(24,167,163,.55);border-radius:12px;padding:14px"><div style="font-family:Barlow Condensed,sans-serif;font-weight:900;font-size:26px;color:#46bfba">$409</div><div style="font-size:11px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;margin-top:6px;opacity:.88">All-LOXX Series</div></div>'
      +'</div>'
      +'<p style="font-size:13px;opacity:.8;margin:0 0 18px">RV hybrid Mag + LOXX included · free shipping lower 48</p>'
      +'<div style="display:flex;flex-wrap:wrap;gap:10px;justify-content:center">'
      +'<a href="/pages/loxx" style="display:inline-flex;padding:14px 20px;border-radius:10px;background:#18a7a3;color:#fff;font-family:Barlow Condensed,sans-serif;font-weight:800;font-size:13px;letter-spacing:.08em;text-transform:uppercase;text-decoration:none">Why LOXX · full story</a>'
      +'<a href="#fitment" style="display:inline-flex;padding:14px 20px;border-radius:10px;border:1px solid rgba(244,241,236,.25);color:#F4F1EC;font-family:Barlow Condensed,sans-serif;font-weight:800;font-size:13px;letter-spacing:.08em;text-transform:uppercase;text-decoration:none">Find My Cover</a>'
      +'</div></div></section>';
    var old=document.getElementById('loxx');
    if(old) old.outerHTML=html;
    else {
      var a=document.querySelector('.sys-creds')||document.querySelector('.jm-trust')||document.querySelector('section.hero');
      if(a) a.insertAdjacentHTML('afterend', html);
    }
  }

  function expandLoxxPageHero(){
    if(!isLoxxPage()) return;
    var hero=document.querySelector('.lxp-hero .wrap')||document.querySelector('.lxp-hero');
    if(!hero) return;
    if(hero.getAttribute('data-trust-expanded')==='1') return;
    var text=hero.textContent||'';
    // If full new copy already present, still ensure trust pills exist
    if(text.indexOf('trust badge only FIT has')!==-1 && hero.querySelector('.lxp-trust-row')){
      hero.setAttribute('data-trust-expanded','1');
      return;
    }
    var h1=hero.querySelector('h1');
    if(!h1) return;

    // Remove thin old heritage paragraphs (first 1-2 p after h1) and inject expanded block
    var node=h1.nextElementSibling;
    var removed=0;
    while(node && node.tagName==='P' && removed<3){
      var n=node.nextElementSibling;
      // stop if we hit buttons
      if(node.classList && node.classList.contains('btns')) break;
      node.parentNode.removeChild(node);
      node=n;
      removed++;
    }

    var block=document.createElement('div');
    block.className='lxp-trust-expand';
    block.innerHTML=''
      +'<p class="lxp-heritage" style="font-size:19px;line-height:1.6;max-width:70ch;margin:0 0 14px;color:rgba(247,244,238,.88)">'
      +'<strong style="color:#F7F4EE">This is the trust badge only FIT has.</strong> LOXX® has spent roughly <strong style="color:#F7F4EE">~100 years</strong> on one craft: '
      +'engineering how to fasten one thing to another so the connection does not come apart under load, vibration, and weather. '
      +'Their positive-lock fasteners are used in environments that do not tolerate failure — <strong style="color:#F7F4EE">military, aerospace, and marine</strong> applications '
      +'where a loose connection is not “inconvenient,” it is unacceptable.</p>'
      +'<p style="font-size:17.5px;line-height:1.6;max-width:70ch;margin:0 0 14px;color:rgba(247,244,238,.84)">'
      +'That pedigree is exactly why FIT partnered with LOXX® as the <strong style="color:#F7F4EE">exclusive North American partner</strong> for glass protection systems. '
      +'We are not bolting on generic hardware. We put century-tested fastening discipline into model-specific UTV and RV covers so they stay planted on highway miles, crosswinds, and real outdoor abuse — '
      +'while protecting glass that can run <strong style="color:#F7F4EE">$500+ on a UTV</strong> and <strong style="color:#F7F4EE">$3,000+</strong> on an RV, plus the trip you lose if it cracks.</p>'
      +'<p style="font-size:16.5px;line-height:1.6;max-width:70ch;margin:0 0 18px;color:rgba(247,244,238,.84)">'
      +'<strong style="color:#F7F4EE">Nobody else offers this stack.</strong> Magnets align the cover. LOXX® locks it down. Built in Arizona. Free shipping lower 48. '
      +'<strong style="color:#F7F4EE">UTV:</strong> Magnetic Series from <strong style="color:#F7F4EE">$364</strong> or All-LOXX® at <strong style="color:#F7F4EE">$409</strong> — pick one system. '
      +'<strong style="color:#F7F4EE">RV:</strong> hybrid Mag + LOXX® included at the load-bearing points.</p>'
      +'<div style="display:flex;flex-wrap:wrap;gap:10px;margin:4px 0 22px;max-width:820px">'
      +'<div style="flex:1 1 120px;min-width:110px;border:1px solid rgba(244,241,236,.18);border-radius:12px;padding:12px;background:rgba(244,241,236,.05)"><b style="display:block;font-family:Barlow Condensed,sans-serif;font-weight:900;font-size:14px;letter-spacing:.04em;text-transform:uppercase;color:#46bfba;margin-bottom:4px">~100 years</b><span style="font-size:12.5px;color:rgba(247,244,238,.8)">Fastening expertise</span></div>'
      +'<div style="flex:1 1 120px;min-width:110px;border:1px solid rgba(244,241,236,.18);border-radius:12px;padding:12px;background:rgba(244,241,236,.05)"><b style="display:block;font-family:Barlow Condensed,sans-serif;font-weight:900;font-size:14px;letter-spacing:.04em;text-transform:uppercase;color:#46bfba;margin-bottom:4px">Military</b><span style="font-size:12.5px;color:rgba(247,244,238,.8)">Mission-grade hold</span></div>'
      +'<div style="flex:1 1 120px;min-width:110px;border:1px solid rgba(244,241,236,.18);border-radius:12px;padding:12px;background:rgba(244,241,236,.05)"><b style="display:block;font-family:Barlow Condensed,sans-serif;font-weight:900;font-size:14px;letter-spacing:.04em;text-transform:uppercase;color:#46bfba;margin-bottom:4px">Aerospace</b><span style="font-size:12.5px;color:rgba(247,244,238,.8)">Failure not an option</span></div>'
      +'<div style="flex:1 1 120px;min-width:110px;border:1px solid rgba(244,241,236,.18);border-radius:12px;padding:12px;background:rgba(244,241,236,.05)"><b style="display:block;font-family:Barlow Condensed,sans-serif;font-weight:900;font-size:14px;letter-spacing:.04em;text-transform:uppercase;color:#46bfba;margin-bottom:4px">Marine</b><span style="font-size:12.5px;color:rgba(247,244,238,.8)">Weather &amp; vibration</span></div>'
      +'<div style="flex:1 1 120px;min-width:110px;border:1.5px solid rgba(24,167,163,.55);border-radius:12px;padding:12px;background:rgba(24,167,163,.08)"><b style="display:block;font-family:Barlow Condensed,sans-serif;font-weight:900;font-size:14px;letter-spacing:.04em;text-transform:uppercase;color:#46bfba;margin-bottom:4px">Exclusive NA</b><span style="font-size:12.5px;color:rgba(247,244,238,.8)">FIT × LOXX only</span></div>'
      +'</div>';

    h1.insertAdjacentElement('afterend', block);
    hero.setAttribute('data-trust-expanded','1');
  }

  function run(){
    injectHome();
    expandLoxxPageHero();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  setTimeout(run, 200);
  setTimeout(run, 800);
})();


/* Contact form assist loader (Clarity form abandon) */
(function(){
  try {
    if (!/\/pages\/contact/i.test(location.pathname||'')) return;
    if (window.__fitFormAssist || window.__fitFormAssistLoading) return;
    window.__fitFormAssistLoading = true;
    var s=document.createElement('script');
    s.src='/cdn/shop/t/102/assets/fit-form-assist.js?v=formassist1';
    s.async=true;
    (document.head||document.documentElement).appendChild(s);
  } catch(e){}
})();
